<template>
  <div>
    <el-descriptions v-if="disabled" size="medium">
      <el-descriptions-item label="取消时间">
        {{ cancelDate }}
      </el-descriptions-item>
    </el-descriptions>
    <el-table
      ref="table"
      :data="pageTableData"
      border
      :row-key="new Date().toString()"
      :header-cell-style="{ background: '#f5f5f5' }"
    >
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
        fixed="left"
      />

      <el-table-column
        align="center"
        show-overflow-tooltip
        label="品目名称"
        prop="materielName"
        width="110"
        fixed
      >
        <template v-slot="{ row }">
          <span>{{ row.materielName || ' - ' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="showTableColumn('materielCode')"
        align="center"
        label="品目编码"
        show-overflow-tooltip
        prop="materielCode"
        width="80"
        fixed
      >
        <template v-slot="{ row }">
          <span>{{ row.materielCode || ' - ' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="showTableColumn('materielNum')"
        align="center"
        label="数量"
        show-overflow-tooltip
        prop="materielNum"
        width="80"
        fixed
      >
        <template v-slot="{ row }">
          <span>
            {{ row.materielNum ? strToThousands(row.materielNum) : 0 }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="showTableColumn('materielModel')"
        align="center"
        label="参数型号"
        show-overflow-tooltip
        prop="materielModel"
        width="100"
        fixed
      >
        <template v-slot="{ row }">
          <span>{{ row.materielModel || ' - ' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="showTableColumn('materielBrand')"
        align="center"
        label="品牌/制造商"
        show-overflow-tooltip
        prop="materielBrand"
        min-width="110"
      >
        <template v-slot="{ row }">
          <span>{{ row.materielBrand || ' - ' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="showTableColumn('deliveryAddress')"
        align="center"
        label="交货地点"
        show-overflow-tooltip
        prop="deliveryAddress"
        width="90"
      >
        <template v-slot="{ row }">
          <span>{{ row.deliveryAddress || ' - ' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="showTableColumn('deliveryDay')"
        align="center"
        label="交货时间(天)"
        show-overflow-tooltip
        prop="deliveryDay"
        width="110"
      >
        <template v-slot="{ row }">
          <span>{{ row.deliveryDay || ' - ' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="showTableColumn('totalPrice')"
        align="center"
        :label="`预算总价(${isDollar ? '美元' : '元'})`"
        show-overflow-tooltip
        width="160"
      >
        <template v-slot="{ row }">
          <div>
            {{ row.totalPrice ? strToThousands(row.totalPrice) : '-' }}
            <money-in-cn
              v-if="!isDollar"
              :money="row.totalPrice"
              :ellipsis="false"
            />
          </div>
          <div v-if="row.targetTotalPrice">
            目标总价:
            {{
              row.targetTotalPrice ? strToThousands(row.targetTotalPrice) : '-'
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="报价供应商数量" min-width="120px">
        <template v-slot="{ row }">
          <span>{{ getMaterialQuoteSupplierNum(row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!disabled"
        label="操作"
        align="center"
        width="120px"
      >
        <template v-slot="{ row }">
          <el-button type="text" @click="$emit('cancelFlow', row)">
            退回授标
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--前端模拟分页-->
    <pagination
      v-show="tableDataTemp.length > size"
      :total="tableDataTemp.length"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />

    <el-form
      :model="formData"
      label-width="110px"
      label-suffix="："
      class="m-t-20 detail-content-width"
    >
      <el-form-item label="取消采购原因">
        <span v-if="disabled">{{ formData.cancelReason || '-' }}</span>

        <template v-else>
          <el-select v-model="cancelReasonValue">
            <el-option
              v-for="item in materialFlowReasonDict.array"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-input
            v-if="cancelReasonValue === materialFlowReasonDict.OTHER.value"
            v-model="formData.cancelReason"
            type="textarea"
            :rows="4"
            :maxlength="500"
            show-word-limit
            class="m-t-10"
          />
        </template>
      </el-form-item>

      <el-form-item label="说明文件">
        <upload
          :file-id-before.sync="formData.cancelAttachmentIds"
          :props-data="{
            uploadMode: 'fileId',
            limit: 10,
            disabled: disabled
          }"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload'
import Pagination from '@/components/common/Pagination'
import MoneyInCn from '@/components/common/MoneyInCn'

// Mixin
import materialColumnMixin from '@/components/common/PurchaseListComponent/material-column-mixin'

// 数据字典
import { materialFlowReasonDict } from '@/dictionary/project/common'

// 工具函数
import { strToThousands } from '@/utils/utils'
import { uniqBy } from 'lodash'

// api接口
import { getHeaderSettingApi } from '@/api/project-view'

export default {
  name: 'FlowItemSheetWuling',

  components: { Upload, Pagination, MoneyInCn },

  mixins: [materialColumnMixin],

  props: {
    tableData: {
      type: Array,
      default: () => []
    },

    // 是否为美元报价
    isDollar: {
      type: Boolean,
      default: false
    },

    // 取消采购原因的对象，sync
    reasonForm: {
      type: Object,
      default: () => {}
    },

    disabled: {
      type: Boolean,
      default: false
    },

    // 取消时间
    cancelDate: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      // 字典
      materialFlowReasonDict,

      // 前端模拟分页
      page: 1,
      size: 20,
      pageTableData: [],

      formData: {
        cancelReason: null,
        cancelAttachmentIds: []
      },

      headerInfo: ''
    }
  },

  computed: {
    // 对传入的品目进行去重
    tableDataTemp() {
      return uniqBy(this.tableData, 'materielId')
    },

    // 退货原因的value，用于这只formData的cancelReason
    cancelReasonValue: {
      get() {
        if (this.formData.cancelReason === null) return null

        const index = materialFlowReasonDict.array.findIndex(
          dict => dict.label === this.formData.cancelReason
        )
        if (index >= 0) {
          return materialFlowReasonDict.array[index]?.value
        } else {
          return materialFlowReasonDict.OTHER.value
        }
      },
      set(val) {
        if (val !== materialFlowReasonDict.OTHER.value) {
          this.formData.cancelReason =
            materialFlowReasonDict.translate(val)?.label || ''
        } else {
          this.formData.cancelReason = ''
        }
      }
    },

    listOption() {
      const totalOptions = [
        {
          label: '品目名称',
          prop: 'materielName',
          fixed: true
        },
        {
          label: '品目编码',
          prop: 'materielCode'
        },
        {
          label: '数量',
          prop: 'materielNum'
        },
        {
          label: '参数型号',
          prop: 'materielModel'
        },
        {
          label: '品牌/制造商',
          prop: 'materielBrand'
        },
        {
          label: '交货地点',
          prop: 'deliveryAddress'
        },
        {
          label: '交货时间(天)',
          prop: 'deliveryDay'
        },
        {
          label: `预算单价(${this.isDollar ? '美元' : '元'})`,
          prop: 'budgetUnitPrice'
        },
        {
          label: `预算总价(${this.isDollar ? '美元' : '元'})`,
          prop: 'totalPrice'
        }
      ]
      return totalOptions.map(el => {
        if (this.headerInfo.includes(el.prop) || el.prop === 'materielName') {
          el.isShow = true
        } else {
          el.isShow = false
        }
        el.hide = !el.isShow
        return el
      })
    },

    listOptionObj() {
      const obj = {}
      this.listOption.forEach(el => {
        obj[el.prop] = el
      })
      return obj
    }
  },

  watch: {
    tableData: {
      handler(val) {
        console.log('watch table data', val)
        this.getPageData()
      },
      deep: true,
      immediate: true
    },

    size() {
      this.getPageData()
    },

    page() {
      this.getPageData()
    },

    // 通过监听reasonForm和formData实现双向绑定
    reasonForm: {
      handler: function(val) {
        this.formData = Object.assign({}, this.formData, val)
      },
      immediate: true
    },
    formData: {
      handler: function(val) {
        if (JSON.stringify(this.reasonForm) === JSON.stringify(val)) return

        this.$emit('update:reasonForm', val)
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    this.getHeader()
  },

  methods: {
    strToThousands,

    /**
     * 获取品目报价供应商数量
     * @param row
     * @returns {number|number|*}
     */
    getMaterialQuoteSupplierNum(row) {
      if ('supplierNum' in row) return row.supplierNum || 0

      return (
        Object.keys(row.offerValue || {}).filter(key => {
          const value = row.offerValue[key]
          return value.tradeId
        }).length || 0
      )
    },

    /**
     * 获取表头设置
     */
    async getHeader() {
      try {
        const { data } = await getHeaderSettingApi(10)
        this.headerInfo = data.headerList || ''
        this.tableKey = !this.tableKey
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    /**
     * 是否展示某一列
     */
    showTableColumn(id) {
      return this.listOptionObj[id]?.isShow
    },

    /**
     * 前端模拟分页：获取分页数据
     */
    getPageData() {
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageTableData = this.tableDataTemp.slice(start, end)
    }
  }
}
</script>

<style scoped lang="scss"></style>
